'use client';

import React, { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useSubscription } from '@/lib/hooks/useSubscription';
import { useAuth } from '@/contexts/AuthContext';

const EXEMPT_PATHS = [
  '/trial-expired',
  '/pricing',
  '/sign-up-login-screen',
  '/landing-page',
  '/privacy-policy',
  '/terms',
  '/contact',
  '/help-center',
  '/auth',
  '/welcome',
];

export default function ExpiredGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { isExpired, loading } = useSubscription();
  const router = useRouter();
  const pathname = usePathname();

  const isExempt = EXEMPT_PATHS.some((p) => pathname?.startsWith(p));

  useEffect(() => {
    if (!loading && user && isExpired && !isExempt) {
      router.replace('/trial-expired');
    }
  }, [loading, user, isExpired, isExempt, router]);

  // While loading or about to redirect, render children normally
  // (avoids flash of wrong content)
  return <>{children}</>;
}
